export const TEST_STATUS = {
  IDLE: 'idle',
  RUNNING: 'running',
  PASSED: 'passed',
  FAILED: 'failed',
};

export async function runSingleTest(test, onStatusChange) {
  onStatusChange(test.id, TEST_STATUS.RUNNING, null, null, null, []);
  const start = Date.now();
  try {
    const result = await test.run();
    const duration = Date.now() - start;
    const snapshot = result?.snapshot ?? null;
    const logs = result?.logs ?? [];
    onStatusChange(test.id, TEST_STATUS.PASSED, null, duration, snapshot, logs);
  } catch (error) {
    const duration = Date.now() - start;
    onStatusChange(test.id, TEST_STATUS.FAILED, error.message, duration, null, []);
  }
}

export async function runTestSuite(suite, onStatusChange) {
  for (const test of suite.tests) {
    await runSingleTest(test, onStatusChange);
    // Allow React's scheduler to drain stale passive-cleanup tasks from the
    // previous test before the next render starts.
    await new Promise(r => setTimeout(r, 100));
  }
}

export async function runAllTests(registry, onStatusChange) {
  for (const suite of registry) {
    await runTestSuite(suite, onStatusChange);
  }
}

export function initTestStatuses(registry) {
  const statuses = {};
  for (const suite of registry) {
    for (const test of suite.tests) {
      statuses[test.id] = { status: TEST_STATUS.IDLE, error: null, duration: null, snapshot: null, logs: [] };
    }
  }
  return statuses;
}

export function getSuiteStats(suite, statuses) {
  const tests = suite.tests;
  const total = tests.length;
  const passed = tests.filter(t => statuses[t.id]?.status === TEST_STATUS.PASSED).length;
  const failed = tests.filter(t => statuses[t.id]?.status === TEST_STATUS.FAILED).length;
  const running = tests.filter(t => statuses[t.id]?.status === TEST_STATUS.RUNNING).length;
  return { total, passed, failed, running };
}
